import React, { useState } from 'react';
import { Form, Card, Space, Row, Col, Select, Input, message } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import { history } from 'app/history';
import {
  useGetTrhmrListQuery,
  useCreateTrhmrLogBookMutation
} from '../../redux/apiSlice';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import Spinner from '../../../../common/Spinner';
import CustomModal from '@/common/CustomModal';

const AdminPage = () => {
  const [form] = Form.useForm();
  const params = useParams();
  const [isModal, setIsModal] = useState(false);
  const { data, error, isLoading } = useGetTrhmrListQuery({
    id: params.id
  });

  const handleModel = async () => {
    await form.validateFields();
    setIsModal(true);
  };

  const handleClose = () => {
    setIsModal(false);
  };

  const [createTrhmrLogBook] = useCreateTrhmrLogBookMutation();
  const onFinish = async (values) => {
    // setSubmitButtonDisabled(true);
    console.log(values, 'values');
    values.employee_id = values.email;
    params.id ? (values.id = params.id) : '';
    data?.data?.trhmr_log_book_details?.[0]?.id
      ? (values.logbook_detail_id = data?.data?.trhmr_log_book_details?.[0]?.id)
      : '';
    values.areaNameMasterId = data?.data?.areaNameMasterId;
    (values.thermoHygrometerIdMasterId =
      data?.data?.thermoHygrometerIdMasterId),
      (values.temperature_limit =
        data?.data?.area_name_master?.temperature_limit),
      (values.hygrometer_calibration =
        data?.data?.thermo_hygrometer_id_master?.hygrometer_calibration_due_date),
      (values.relative_humidity_limit =
        data?.data?.area_name_master?.relative_humidity),
      (values.period = data?.data?.trhmr_log_book_details?.[0]?.period);
    // (values.temperature_minimum =
    //   data?.data?.trhmr_log_book_details?.[0]?.temperature_minimum),
    // (values.temperature_maximum =
    //   data?.data?.trhmr_log_book_details?.[0]?.temperature_maximum),
    // (values.temperature =
    //   data?.data?.trhmr_log_book_details?.[0]?.temperature),
    // (values.relative_humidity_minimum =
    //   data?.data?.trhmr_log_book_details?.[0]?.relative_humidity_minimum),
    // (values.relative_humidity_maximum =
    //   data?.data?.trhmr_log_book_details?.[0]?.relative_humidity_maximum);
    const response = await createTrhmrLogBook({
      ...values

      // records: [
      //   {
      //     ...values
      //   }
      // ]
    });
    if (response?.data?.success === true) {
      message.success(response?.data?.message);
      setTimeout(() => history.push('/log-books-trhmr-list'), 1500);
    } else {
      // setSubmitButtonDisabled(false);
      message.error(response.data?.message);
    }
  };

  let content;
  if (isLoading) {
    console.log('Loading.....');
    content = <Spinner />;
  } else if (data) {
    console.log('data =', data);
    content = (
      <Space>
        <Layout sider={false}>
          <Form form={form} layout="vertical">
            <Card
              title={'TEMPERATURE AND RELATIVE HUMIDITY MONITORING RECORD'}
              className={styles.CustomPanel}
            >
              <Row gutter={24}>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Area Name"
                    name="areaNameMasterId"
                    className={styles.customLable}
                  >
                    <Select
                      disabled={true}
                      defaultValue={data?.data?.area_name_master?.areaName}
                    ></Select>
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={24} md={24} sm={24}>
                  <FormItem
                    label="Thermo-Hygrometer ID No."
                    name="thermoHygrometerIdMasterId"
                    className={styles.customLable}
                  >
                    <Select
                      disabled={true}
                      defaultValue={
                        data?.data?.thermo_hygrometer_id_master
                          ?.thermo_hygrometer_id
                      }
                    ></Select>
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={24} md={24} sm={24}>
                  <FormItem
                    label="Temperature Limit (&deg;C)"
                    name="temperature_limit"
                    className={styles.customLable}
                  >
                    <Input
                      placeholder=""
                      style={{ width: '100%' }}
                      disabled={true}
                      defaultValue={
                        data?.data?.area_name_master?.temperature_limit
                      }
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Hygrometer Calibration Due Date"
                    name="hygrometer_calibration"
                    className={styles.customLable}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={true}
                      defaultValue={moment(
                        data?.data?.thermo_hygrometer_id_master
                          ?.hygrometer_calibration_due_date
                      ).format('DD-MMM-YYY')}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={24} md={24} sm={24}>
                  <FormItem
                    label="Relative Humidity (&deg;C)"
                    name="relative_humidity_limit"
                    className={styles.customLable}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={true}
                      defaultValue={
                        data?.data?.area_name_master?.relative_humidity
                      }
                    />
                  </FormItem>
                </Col>
              </Row>
            </Card>
            <br />

            {data?.data?.trhmr_log_book_details.length > 0 ? (
              <Form form={form} layout="vertical">
                {data.data?.trhmr_log_book_details?.map((obj) => (
                  <>
                    <Card
                      title={`Reading between ${obj.period}`}
                      className={styles.CustomPanel}
                    >
                      <Row gutter={24}>
                        <Col xs={24} xl={12} span={12} md={24} sm={24}>
                          <FormItem
                            label="Date"
                            name={`date`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={moment(obj.verified_by_date).format(
                                'DD-MMM-YYYY'
                              )}
                              disabled={true}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={12} md={24} sm={24}>
                          <FormItem
                            label="Time"
                            name={`time`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={moment(obj.verified_by_date).format(
                                'HH:mm'
                              )}
                              disabled={true}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Temperature Minimum (&deg;C)"
                            name={`temperature_minimum`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={obj.temperature_minimum}
                              disabled={false}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Temperature Maximum (&deg;C)"
                            name={`temperature_maximum`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={obj.temperature_maximum}
                              disabled={false}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Temperature (&deg;C)"
                            name={`temperature`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={obj.temperature}
                              disabled={false}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Relative Humidity Minimum (&deg;C)"
                            name={`relative_humidity_minimum`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={obj.relative_humidity_minimum}
                              disabled={false}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Relative Humidity Maximum (&deg;C)"
                            name={`relative_humidity_maximum`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={obj.relative_humidity_maximum}
                              disabled={false}
                            />
                          </FormItem>
                        </Col>
                        {/* <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Relative Humidity (&deg;C)"
                            name={`relative_humidity${index}`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={obj.relative_humidity}
                              disabled={false}
                            />
                          </FormItem>
                        </Col> */}
                        {/* <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Verified By (User id & Date)"
                            name={`verified_by_user_id${index}`}
                            className={styles.customLable}
                          >
                            <Input
                              defaultValue={`${
                                obj.verified_by_user_id
                              } & ${moment(obj.verified_by_date).format(
                                'DD-MMM-YYYY'
                              )}`}
                              disabled={false}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Remarks"
                            name={`remarks${index}`}
                            className={styles.customLable}
                          >
                            <Input.TextArea
                              defaultValue={obj.remarks}
                              disabled={false}
                            />
                          </FormItem>
                        </Col> */}
                      </Row>
                    </Card>
                    <br />
                  </>
                ))}
              </Form>
            ) : (
              ''
            )}
            <FormItem className="text-center">
              <Space>
                <CustomButton
                  className={styles.inwardButton}
                  htmlType="button"
                  type="primary"
                  onClick={() => handleModel()}
                  // // disabled={verificationButtonDisabled}
                >
                  Initiate Verification
                </CustomButton>

                <CustomButton
                  className={styles.inwardButton}
                  type="primary"
                  ghost
                  onClick={() => history.back()}
                >
                  Back
                </CustomButton>
              </Space>
            </FormItem>
            {isModal ? (
              <CustomModal
                title=""
                visible={isModal}
                width="50%"
                footer={null}
                className={styles.customModal}
                closable={false}
              >
                <div className={`${styles.table_row}`}>
                  {/* <Form form={form2} layout="vertical" onFinish={onFinishModal}> */}
                  <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Card
                      title={'Initiate Verification'}
                      className={styles.CustomPanel}
                    >
                      <Row gutter={24}>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Verified By (User id)"
                            name="email"
                            rules={[
                              {
                                required: true,
                                message: 'Enter Verifier User Id'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input placeholder="Enter Verifier User Id" />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Password"
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: 'Enter Password'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input.Password placeholder="Enter Password" />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={12} span={24} md={24} sm={24}>
                          <FormItem
                            label="Remarks"
                            name="remarks"
                            className={styles.customLable}
                          >
                            <Input.TextArea placeholder="Enter remarks" />
                          </FormItem>
                        </Col>
                      </Row>
                    </Card>

                    <br />
                    <FormItem className="text-center">
                      <Space>
                        <CustomButton
                          className={styles.inwardButton}
                          htmlType="submit"
                          type="primary"
                          size="medium"
                          // onSubmit={(e) => onFinish(e)}
                          // disabled={isModalSubmitDisabled}
                        >
                          Submit
                        </CustomButton>
                        <CustomButton
                          className={styles.inwardButton}
                          onClick={handleClose}
                          type="primary"
                          ghost
                          size="medium"
                        >
                          Close
                        </CustomButton>
                      </Space>
                    </FormItem>
                  </Form>
                </div>
              </CustomModal>
            ) : (
              ''
            )}
          </Form>
        </Layout>
      </Space>
    );
  } else if (error) {
    console.log(error);
    content = 'Something went wrong!';
  }

  return <>{content}</>;
};
export default AdminPage;
